import { motion } from "framer-motion";

const skeletonBlock: any = {
  hidden: { opacity: 0.3 },
  visible: (i: number) => ({
    opacity: 1,
    transition: {
      delay: i * 0.05,
      duration: 0.4,
      ease: "easeInOut",
      repeat: Infinity,
      repeatType: "reverse",
    },
  }),
};

export const ManageColumnSkeleton = () => {
  const visibleFields = new Array(10).fill(0);
  const hiddenFields = new Array(8).fill(0);

  return (
    <div className="bg-white rounded-lg px-4 py-2 h-[calc(100%-60px)] flex flex-col gap-2 justify-between max-w-full">
      {/* Search skeleton */}
      <div className="relative">
        <motion.div
          className="h-8 bg-gray-200 rounded-lg w-full"
          custom={0}
          variants={skeletonBlock}
          initial="hidden"
          animate="visible"
        />
      </div>

      <div className="flex h-full flex-col gap- max-h-[calc(100%-100px)] overflow-y-auto">
        {/* Visible columns section */}
        <div className="pt-2">
          <motion.div
            className="h-6 bg-gray-200 rounded w-24 mb-2"
            custom={1}
            variants={skeletonBlock}
            initial="hidden"
            animate="visible"
          />
          {visibleFields.map((_, i) => (
            <motion.div
              key={`visible-${i}`}
              className="flex items-center py-1 gap-2"
              custom={i + 2}
              variants={skeletonBlock}
              initial="hidden"
              animate="visible"
            >
              <div className="w-6 h-5 bg-gray-200 rounded" />
              <div className="w-6 h-5 bg-gray-200 rounded" />
              <div className="h-4 bg-gray-200 rounded flex-1 " />
            </motion.div>
          ))}
        </div>

        {/* Hidden columns section */}
        <div>
          <motion.div
            className="h-6 mt-3 bg-gray-200 rounded w-24 mb-2"
            custom={visibleFields.length + 2}
            variants={skeletonBlock}
            initial="hidden"
            animate="visible"
          />
          {hiddenFields.map((_, i) => (
            <motion.div
              key={`hidden-${i}`}
              className="flex items-center py-1 gap-2"
              custom={visibleFields.length + i + 3}
              variants={skeletonBlock}
              initial="hidden"
              animate="visible"
            >
       <div className="w-6 h-5 bg-gray-200 rounded" />
              <div className="w-6 h-5 bg-gray-200 rounded" />
              <div className="h-4 bg-gray-200 rounded flex-1 " />
            </motion.div>
          ))}
        </div>
      </div>

      {/* Buttons skeleton */}
      <div className="flex justify-between gap-2">
        <motion.div
          className="h-8 w-24 bg-gray-200 rounded"
          custom={visibleFields.length + hiddenFields.length + 3}
          variants={skeletonBlock}
          initial="hidden"
          animate="visible"
        />
        <div className="flex gap-x-4">
          <motion.div
            className="h-8 w-16 bg-gray-200 rounded"
            custom={visibleFields.length + hiddenFields.length + 4}
            variants={skeletonBlock}
            initial="hidden"
            animate="visible"
          />
          <motion.div
            className="h-8 w-24 bg-gray-200 rounded"
            custom={visibleFields.length + hiddenFields.length + 5}
            variants={skeletonBlock}
            initial="hidden"
            animate="visible"
          />
        </div>
      </div>
    </div>
  );
};

export default ManageColumnSkeleton;
